import { EnrollmentContextService } from '../enrollment-context';
import { Person } from '../types';
import { telecomMapper } from './telecom';

export const contactMapper = (
	enrollmentContext: EnrollmentContextService,
	flag = ''
): Person => {
	const addressFlag = enrollmentContext.getFormField('checkedSameAddress')
		?.value
		? ''
		: flag;
	const dob = enrollmentContext.getFormField('dob' + flag)?.value as string;
	const line = [
		enrollmentContext.getFormField('mail' + addressFlag)?.value as string,
	];
	const apt = enrollmentContext.getFormField('apt' + addressFlag)?.value;
	if (apt) {
		line.push(apt as string);
	}
	const address = {
		city: enrollmentContext.getFormField('city' + addressFlag)?.value as string,
		country: 'US',
		line,
		postalCode: enrollmentContext.getFormField('zip' + addressFlag)
			?.value as string,
		state: enrollmentContext.getFormField('state' + addressFlag)
			?.value as string,
		use: 'home',
		type: 'both',
	};
	const name = {
		family: (enrollmentContext.getFormField('lastname' + flag)?.value as string).trim(),
		given: [
			(enrollmentContext.getFormField('firstname' + flag)?.value as string).trim(),
		] as string[],
	};
	const contact = {
		name: flag ? name : [name],
		telecom: telecomMapper(enrollmentContext),
		address: flag ? address : [address],
		gender: enrollmentContext.getFormField('gender' + flag)?.value as string,
		birthDate: dob
	};
	return contact;
};
